<template>
<div id="myClient">
  <div class="search">
    <div class="searchInput">
      <el-input v-model="searchParams.selectKey" placeholder="请输入订单编号" clearable></el-input>
    </div>
    <div class="searchInput">
      <el-input v-model="searchParams.mobile" placeholder="请输入用户手机号" clearable></el-input>
    </div>
    <div class="searchInput">
      <el-input v-model="searchParams.goodsName" placeholder="请输入商品名称" clearable></el-input>
    </div>
    <div class="searchInput">
      <el-input v-model="searchParams.agentTel" placeholder="请输入合伙人手机号" clearable></el-input>
    </div>
    <div class="searchInput">
      <el-date-picker
          v-model="searchParams.time"
          type="datetimerange"
          range-separator="至"
          start-placeholder="请选择支付时间"
          end-placeholder="请选择支付时间"
          value-format="yyyy-MM-dd HH:mm:ss"
          :default-time="['00:00:00', '23:59:59']"
          @change="submitSearch"
          clearable>
        </el-date-picker>
    </div>
    <div class="searchInput">
      <el-select v-model="searchParams.bindWorkNumber" @change="submitSearch" placeholder="请选择所属管家" clearable>
        <el-option :label="item" :value="item" v-for="item in listMan" :key="item.name"></el-option>
      </el-select>
    </div>
    <div class="searchInput">
      <el-select v-model="searchParams.orderCatagory" @change="submitSearch" placeholder="请选择订单类型" clearable>
        <el-option label="O2O" :value="0"></el-option>
        <el-option label="实物" :value="1"></el-option>
        <el-option label="VIP" :value="2"></el-option>
        <el-option label="SVIP" :value="3"></el-option>
        <!-- <el-option label="油品" :value="4"></el-option> -->
        <el-option label="其他" :value="5"></el-option>
        <el-option label="次卡" :value="6"></el-option>
      </el-select>
    </div>
    <div class="searchInput">
      <el-select v-model="searchParams.paymentState" @change="submitSearch" placeholder="请选择订单状态" clearable>
        <el-option label="已付款" value="1"></el-option>
        <el-option label="已预约" value="10"></el-option>
        <el-option label="已消费" value="11"></el-option>
        <el-option label="已退款" value="2"></el-option>
        <el-option label="已完成" value="3"></el-option>
        <el-option label="待评价" value="21"></el-option>
        <el-option label="已发货" value="20"></el-option>
        <el-option label="已过期" value="4"></el-option>
      </el-select>
    </div>
    <div style="margin:10px 4px 0 4px;display: inline-block;">
      <el-button type="primary" @click="submitSearch">搜索</el-button>
    </div>
    <div style="margin:10px 0px 0 4px;display: inline-block;">
      <el-button type="primary" @click="searchClear(1)">清除</el-button>
    </div>
  </div>
  <!-- 表格 -->
  <div class="contentView">
    <div class="top_table">
      <div class="left">
        <div class="tip_btn"><i class="el-icon-warning-outline"></i>已选择<span style="color:#25a0ef;">{{selectLength}}</span>项，建议每次总数不大于<span>50</span>项</div>
        <div class="tip_btn" style="color:#25a0ef;cursor:pointer;" @click="toggleSelection()" v-if="selectLength > 0">清空</div>
      </div>
      <div class="right" v-if="selectLength > 0">
        <div class="right_btn" @click="creatTask()">创建任务</div>
      </div>
    </div>
    <el-table :data="tableData" ref="multipleTable" tooltip-effect="dark" :row-key="getRowKeys1" @selection-change="handleSelectionChange" style="width: 100%;">
      <el-table-column
        type="selection"
        :reserve-selection="true"
        width="55">
      </el-table-column>
      <el-table-column
        prop="goodsName"
        label="商品名称"
        min-width="100">
      </el-table-column>
      <el-table-column
        prop="gcName"
        label="所属商品分类"
        min-width="100">
      </el-table-column>
      <el-table-column
        prop="orderSn"
        label="订单编号"
        min-width="100">
      </el-table-column>
      <el-table-column
        prop="orderCatagory"
        label="订单类型"
        min-width="50">
        <template slot-scope="scope">
          <span v-if="scope.row.orderCatagory === 0">O2O</span>
          <span v-if="scope.row.orderCatagory === 1">实物</span>
          <span v-if="scope.row.orderCatagory === 2">VIP</span>
          <span v-if="scope.row.orderCatagory === 3">SVIP</span>
          <span v-if="scope.row.orderCatagory === 4">激活码</span>
        </template>
      </el-table-column>
      <el-table-column
        prop="goodsNum"
        label="数量"
        min-width="50">
      </el-table-column>
      <el-table-column
        prop="buyerTel"
        label="下单会员手机号"
        min-width="100">
      </el-table-column>
      <el-table-column
        prop="payMoney"
        min-width="50"
        label="支付金额">
      </el-table-column>
      <el-table-column
        prop="strPayTime"
        min-width="100"
        label="支付时间">
      </el-table-column>
      <!-- 订单状态区分类型orderCatagory -->
      <!-- 0:O2O 1:实物 2:vip 3:svip 4:激活码 -->
      <el-table-column
        prop="orderState"
        min-width="50"
        label="订单状态">
        <template slot-scope="scope">
          <span v-if="scope.row.orderState == 1">已退款</span>
          <span v-if="scope.row.orderState == 2">已过期</span>
          <span v-if="scope.row.orderState == 3">未支付</span>
          <span v-if="scope.row.orderState == 4">已付款</span>
          <span v-if="scope.row.orderState == 5">已预约</span>
          <span v-if="scope.row.orderState == 6">已付款</span>
          <span v-if="scope.row.orderState == 7">已发货</span>
          <span v-if="scope.row.orderState == 8 && scope.row.orderCatagory == 0">已消费</span>
          <span v-if="scope.row.orderState == 8 && scope.row.orderCatagory == 1">待评价</span>
          <span v-if="scope.row.orderState == 9 && (scope.row.orderCatagory == 2 || scope.row.orderCatagory == 3)">已付款</span>
          <span v-if="scope.row.orderState == 9 && (scope.row.orderCatagory == 0 || scope.row.orderCatagory == 1)">已完成</span>
        </template>
      </el-table-column>
      <el-table-column
        prop="bindWorkNumber"
        min-width="50"
        label="所属管家">
      </el-table-column>
      <el-table-column
        prop="agentTel"
        min-width="80"
        label="所属合伙人">
      </el-table-column>
      <el-table-column
        prop="isPartneroOder"
        label="是否合伙人订单"
        min-width="100">
        <template slot-scope="scope">
          <span v-if="!scope.row.agentTel">否</span>
          <span v-if="scope.row.agentTel">是</span>
        </template>
      </el-table-column>
      <!-- <el-table-column
        prop="operatorName"
        label="操作人"
        min-width="120">
      </el-table-column> -->
      <el-table-column
        class="tableOptions"
        label="操作"
        min-width="120">
        <template slot-scope="scope">
          <span class="to_able" @click="openSubmit(scope.row)">订单详情</span>
        </template>
      </el-table-column>
    </el-table>
    <div class="pagination">
      <el-pagination
        @size-change="sizeChange"
        @current-change="handleCurrentChange"
        :current-page.sync="currentPage"
        :page-sizes="[10,20,30,40]"
        :page-size="searchParams.pageSize"
        prev-text="上一页"
        next-text="下一页"
        layout="slot, sizes, prev, pager, next, jumper">
        <span class="el-pagination__sizes">第{{currentPage}}页</span>
      </el-pagination>
    </div>
  </div>
  <el-dialog title="提交确认" :visible.sync="dialog.submit.show" width="500px">
    <div class="lay-t-a-c">
      <div class="searchInline">
        你确定要把奖金发放到本人合伙人账户吗？
      </div>
    </div>
    <div class="dialogSubmitBtns">
      <el-button type="primary" @click="submitConfirm()">确定</el-button>
    </div>
  </el-dialog>
</div>
</template>

<script>
import { devCode } from '@/http/baseUrl';
export default {
  name: 'allOrder',
  data () {
    return {
      searchParams: {
        memberid: '',
        mobile: '',
        orderCatagory: '', // 订单分类
        paymentState: '', // 业务状态
        selectKey: '', // 订单编号
        agentTel: '', // 合伙人手机号
        goodsName: '',
        bindWorkNumber: '', // 所属管家工号
        time: '', // 搜索时间段
        pageSize: 10,
        pageIndex: 0
      },
      ids: '',
      tableData: [],
      listMan: [],
      currentPage: 1,
      totalResult: 0,
      totalPage: 0,
      multipleSelection: [],
      newList: [],
      selectLength: 0,
      dialog: {
        submit: {
          show: false,
          userName: '',
          manageId: '',
          batchNo: ''
        }
      }
    };
  },
  created () {
    let params = sessionStorage.getItem('orderParams');
    if (params) {
      setTimeout(() => {
        this.searchParams = JSON.parse(params);
        this.currentPage = parseInt(this.searchParams.pageIndex) + 1;
        this.getList();
      }, 200);
    } else {
      this.getList();
    }
    this.getListMan();
  },
  methods: {
    // 获取列表数据
    getList () {
      this.axios.get('/member/orderList', {
        params: {
          memberid: this.$store.state.memberId,
          buyerTel: this.searchParams.mobile,
          orderCatagory: this.searchParams.orderCatagory, // 订单分类
          paymentState: this.searchParams.paymentState, // 业务状态
          selectKey: this.searchParams.selectKey, // 订单编号
          agentTel: this.searchParams.agentTel || this.$route.query.agentTel, // 合伙人手机号
          goodsName: this.searchParams.goodsName,
          bindWorkNumber: this.searchParams.bindWorkNumber, // 所属管家工号
          beginTime: this.searchParams.time[0], // 搜索开始时间
          endTime: this.searchParams.time[1], // 搜索结束时间
          pageIndex: this.searchParams.pageIndex,
          pageSize: this.searchParams.pageSize
        }
      }).then(res => {
        if (res.data.ok) {
          this.tableData = res.data.data.content;
          this.totalResult = res.data.data.total;
          this.totalPage = res.data.data.pageTotal;
          this.currentPage = res.data.data.pageIndex;
        };
      });
    },
    // 获取管家列表
    getListMan (e) {
      this.axios
        .get(`/member/getManagerWorkNumber`, {
          params: {}
        })
        .then(res => {
          if (res.data.ok) {
            this.listMan = res.data.data;
          }
        });
    },
    // 搜索列表
    submitSearch () {
      this.searchParams.pageIndex = 0;
      this.getList();
      this.currentPage = 1;
    },
    // 搜索列表
    submitSearch1 () {
      this.searchParams.pageIndex = 0;
      this.getList();
      this.currentPage = 1;
    },
    // 清除
    searchClear (num) {
      if (num === 1) {
        this.clearListSearch();
      } else if (num === 2) {
        this.clearListSearch2();
        this.getUserList();
      }
    },
    // 清除列表的搜索表单
    clearListSearch () {
      sessionStorage.removeItem('orderParams');
      this.searchParams = {
        memberid: '',
        mobile: '',
        orderCatagory: '', // 订单分类
        paymentState: '', // 业务状态
        selectKey: '', // 订单编号
        agentTel: '', // 合伙人手机号
        goodsName: '',
        bindWorkNumber: '', // 所属管家工号
        time: '', // 搜索时间段
        pageSize: 10,
        pageIndex: 0
      };
      this.getList();
    },
    // 创建任务
    creatTask () {
      let obj = '';
      this.multipleSelection.forEach(item => {
        obj += item.buyerTel + ',';
      });
      this.newList = obj.substring(0, obj.length - 1);
      this.$router.push({name: 'addTask', query: {table: this.newList, fromUrl: 'order'}});
    },
    toggleSelection (rows) {
      if (rows) {
        rows.forEach(row => {
          this.$refs.multipleTable.toggleRowSelection(row);
        });
      } else {
        this.$refs.multipleTable.clearSelection();
      }
    },
    getRowKeys1 (row) {
      return row.id;
    },
    handleSelectionChange (val) {
      this.multipleSelection = val;
      this.selectLength = val.length;
    },
    // 更改pageSize
    sizeChange (val) {
      this.searchParams.pageSize = val;
      this.searchParams.pageIndex = 0;
      this.getList();
      this.currentPage = 1;
    },
    // 跳页
    handleCurrentChange (val) {
      this.searchParams.pageIndex = val - 1;
      this.getList();
    },
    // 打开订单详情
    openSubmit (obj) {
      console.log(obj);
      sessionStorage.setItem('orderParams', JSON.stringify(this.searchParams));
      this.$router.push({name: 'orderDetail', query: {orderId: obj.id, orderType: obj.orderCatagory}});
    },
    openCall (obj) {
      console.log(obj);
      this.ids = obj.id;
      this.dialog.submit.show = true;
    },
    submitConfirm () {
      this.axios({
        url: `/agentAwardBatch/transfer` + devCode,
        method: 'post',
        data: {
          ids: this.ids
        }
      }).then(res => {
        if (res.data.ok) {
          this.$message.success(res.data.data);
          this.dialog.submit.show = false;
          this.getList();
        } else {
          this.$message.error(res.data.message);
        }
      });
    }
  }
};
</script>
<style lang="scss">
.el-table th div.renderHeader{
  line-height: 14px; padding: 0; margin-top: 4px;
  span{margin-right: 5px;}
  i{cursor: pointer;}
}
</style>
<style>
  .search {width: 100%; padding: 0px 20px 10px; float: left; font-size: 14px;}
  .search .searchInline span { margin-left: 10px; }
  .search .searchInput {display: inline-block; margin: 10px 4px 0 0;}
  .search .searchInline .blue {color: blue;}
  .contentView .top_table {
    margin-top: 20px; display: flex; height: 50px; width: 100%;
    background: #dedccc; padding: 0 10px; justify-content: space-between;
  }
  .contentView .top_table .left {display: flex;}
  .contentView .top_table .tip_btn { font-size: 14px; line-height: 50px;}
  .contentView .top_table .tip_btn:last-child {margin-left: 20px;}
  .contentView .top_table .right_btn {
  font-size: 14px; line-height: 30px; border-radius: 5px 5px;padding: 0 5px;
  background: #25a0ef; color: #fff; height: 30px; margin-top: 10px;cursor: pointer;
}
</style>



// WEBPACK FOOTER //
// src/components/orderQuery/allOrder.vue